import React, { useState } from "react";
import axios from "axios";
import Infoweather from "./Infoweather";
import "./Search.css";
import "./styles.css";
import ForecastWeather from "./Forecast";

export default function WeatherSearch( props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.cityName);

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
      wind: response.data.wind.speed,
      city: response.data.name,
    });
  }  

function getCurrentLocation(){  
  navigator.geolocation.getCurrentPosition(getCoordinates);
}
function getCoordinates(position){
  let  latitude= position.coords.latitude; 
  let longitude= position.coords.longitude;
  let apiKey = "fe1483f743b581b5520a1b725af03a49";
   let apiUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;
  axios.get(apiUrl).then(handleResponse);}

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "5f472b7acba333cd8a035ea85a0d4d4c";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  let form = (
    <div className="card-body">
      <div className="mb-3">
        <form onSubmit={handleSubmit} id="search-form">
          <input
            type="search"
            className="form-control"
            id="formGroupExampleInput"
            placeholder="Enter a city.."
            onChange={updateCity}
          />
          <button
            onClick={handleSubmit}
            type="button"
            className="btn btn-success"
            id="search"> Go! </button>
          <button type="button" className="btn btn-success" id="gps" onClick={getCurrentLocation}>
            Current
          </button>
        </form>
      </div>
    </div>
  );

  if (weatherData.ready) {
    return (
      <div>
        {form}
        <Infoweather data={weatherData}/>
        <ForecastWeather  coordinates= {weatherData.coordinates}/>
        </div>
    );
    
  } else {
    search();
    return "Loading...";
  }
}